import axios from "axios";

export const useGeo = () => {
    // const searchAutocomplete = (address) => {
    //     return new Promise((res, rej) => {
    //         const appleMapManager = window.AppleMapManager();
    //         appleMapManager.searchAutocomplete(address, (error, result) => {
    //             if (null === error) {
    //                 return res(result);
    //             } else {
    //                 return rej(error);
    //             }
    //         });
    //     });
    // };
    const searchAutocomplete = (address, fast = false) => {
        return new Promise(async (res, rej) => {
            try {
                let result = await axios.get(`${process.env.REACT_APP_MAPS_WORKER_URL}/searchAutoComplete?inputAddress=${address}${fast ? "&fast=true" : ""}`);
                for (let i of result.data.results) {
                    i["coordinate"] = {};
                    i.coordinate["latitude"] = i.location.lat;
                    i.coordinate["longitude"] = i.location.lng;
                }
                res(result.data.results);
            } catch (error) {
                // rej("error: " + error.message);
                const appleMapManager = window.AppleMapManager();
                appleMapManager.searchAutocomplete(address, (error, result) => {
                    if (null === error) {
                        return res(result);
                    } else {
                        return rej(error);
                    }
                });
            }
        });
    };

    const geolocalize = () => {
        return new Promise(async (res, rej) => {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    async (position) => {
                        // const appleMapManager = window.AppleMapManager();
                        const result = await geoDecode(position.coords);
                        res({
                            address: result.formattedAddress,
                            coords: {
                                lat: position.coords.latitude,
                                lng: position.coords.longitude,
                            },
                        });

                        // appleMapManager.geoDecode(position.coords.latitude, position.coords.longitude, (result) => {
                        //     res({
                        //         address: result.formattedAddress,
                        //         coords: {
                        //             lat: position.coords.latitude,
                        //             lng: position.coords.longitude,
                        //         },
                        //     });
                        // });
                    },
                    (error) => {
                        rej("Geolocalizzazione disattivata");
                    }
                );
            } else {
                rej("");
            }
        });
    };

    const geoCode = (address) => {
        return new Promise(async (res, rej) => {
            // let result = await axios.get(`https://monforte-maps.monforte.workers.dev/api/geocode?q=${searchString}`);
            // console.log(result);
            // const appleMapManager = window.AppleMapManager();
            // const address = `${searchString.toLowerCase().indexOf("ital") == -1 ? `${searchString}` : searchString}`;
            // appleMapManager.geocode(address, (result) => {
            //     if (null !== result.latitude && null !== result.longitude) {
            //         return res({
            //             cap: result.cap,
            //             lat: result.latitude,
            //             lng: result.longitude,
            //             address: result.address,
            //             city: result.city,
            //             locality: result.locality,
            //         });
            //     } else {
            //         return rej("Indirizzo non trovato");
            //     }
            // });
            let result = await axios.get(`${process.env.REACT_APP_MAPS_WORKER_URL}/geocode?inputAddress=${address}`);
            result = result.data;
            console.log(result);
            if (result.results.length) {
                result = result.results[0];
                if (null !== result.center.lat && null !== result.center.lng) {
                    return res({
                        cap: result.postCode,
                        lat: result.center.lat,
                        lng: result.center.lng,
                        address: result.name,
                        city: result.locality,
                        locality: result.locality,
                        placeType: result.geocodeAccuracy,
                    });
                } else {
                    return rej("Indirizzo non trovato");
                }
            } else {
                return rej("Indirizzo non trovato");
            }
        });
    };

    const geoDecode = (coords) => {
        return new Promise(async (res, rej) => {
            // const appleMapManager = window.AppleMapManager();
            // appleMapManager.geoDecode(coords.lat, coords.lng, (result) => {
            //     if (null !== result.latitude && null !== result.longitude) {
            //         return res(result);
            //     } else {
            //         return rej("Indirizzo non trovato");
            //     }
            // });
            let result = await axios.get(`${process.env.REACT_APP_MAPS_WORKER_URL}/geoDecode?lat=${coords.lat || coords.latitude}&lng=${coords.lng || coords.longitude}`);
            result = result.data;
            console.log(result);
            if (result.results.length) {
                result = result.results[0];
                if (null !== result.center.lat && null !== result.center.lng) {
                    return res({
                        cap: result.postCode,
                        lat: result.center.lat,
                        lng: result.center.lng,
                        address: result.name || result.locality,
                        formattedAddress: result.name || result.locality,
                        city: result.locality,
                        locality: result.locality,
                        placeType: result.geocodeAccuracy,
                    });
                } else {
                    return rej("Indirizzo non trovato");
                }
            } else {
                return rej("Indirizzo non trovato");
            }
        });
    };

    return {
        searchAutocomplete,
        geolocalize,
        geoCode,
        geoDecode,
    };
};
